import { hotkeyManager } from './hotkey_manager';

let initialized = false;

export function initHotkeyListener() {
    if (initialized) return;
    initialized = true;
    let composing = false;

    function isIMEEvent(e) {
        return (
            e.isComposing ||
            e.keyCode === 229 ||
            e.key === 'Process' ||
            e.key === 'Unidentified' ||
            e.key === 'Backspace'
        );
    }

    window.addEventListener(
        "keydown",
        (e) => {
            if (isIMEEvent(e)) {
                hotkeyManager.reset();
                return;
            }
            if (composing) return;
            if (e.repeat) return; // tránh spam
            hotkeyManager.keydown(e);
        },
        true
    );

    window.addEventListener(
        "keyup",
        (e) => {
            if (isIMEEvent(e)) {
                hotkeyManager.reset();
                hotkeyManager.syncFromEvent(e);
                return;
            }
            hotkeyManager.keyup(e);
        },
        true
    );

    window.addEventListener("blur", () => {
        hotkeyManager.reset();
    });
}